import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import BaseSelect from "../inputs/base/BaseSelect.vue";


const __default__ = {
  name: "TimeSelect",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  initialTime: {
    type: String,
    default: "00:00",
  },
},
  emits: ["onUpdateTime"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const hourOptions = computed(() => {
  const options = [];
  for (let i = 0; i < 24; i++) {
    options.push(getHourStr(i));
  }
  return options;
});

const minutesOptions = computed(() => {
  const options = [];
  for (let i = 0; i < 60; i++) {
    // if (i % 5 !== 0) continue;
    options.push(getMinutesStr(i));
  }
  return options;
});

const initialHour = computed(() => props.initialTime.split(":")[0]);
const initialMinutes = computed(() => props.initialTime.split(":")[1]);

const selectedHour = ref(initialHour.value);
const selectedMinutes = ref(initialMinutes.value);

const selectedTime = computed(
  () => `${selectedHour.value}:${selectedMinutes.value}`
);

const getHourStr = (hour: number) => {
  return hour < 10 ? `0${hour}` : `${hour}`;
};

const getMinutesStr = (minutes: number) => {
  return minutes < 10 ? `0${minutes}` : `${minutes}`;
};

const updateHour = (value: string) => {
  selectedHour.value = value;
  emit("onUpdateTime", selectedTime.value);
};

const updateMinutes = (value: string) => {
  selectedMinutes.value = value;
  emit("onUpdateTime", selectedTime.value);
};

watch(
  () => [initialHour.value, initialMinutes.value],
  ([hour, minutes], [oldHour, oldMinutes]) => {
    if (hour === oldHour && minutes === oldMinutes) return;

    selectedHour.value = hour;
    selectedMinutes.value = minutes;
  }
);

const __returned__ = { props, emit, hourOptions, minutesOptions, initialHour, initialMinutes, selectedHour, selectedMinutes, selectedTime, getHourStr, getMinutesStr, updateHour, updateMinutes, BaseSelect }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})